import ModalPopup from "./ModalPopup";

const PopupForm = ({setShow, children, addedClass}: {setShow: (boolean) => void, children: JSX.Element, addedClass?: string}) => {
    return (
        <ModalPopup setShow={setShow} addedClass={addedClass}>
           {children}
        </ModalPopup>
    );
};
export default PopupForm;